import { FirebaseAuth } from '../../../../lib/firebase'
import { isDesktopApp } from './helpers'
import { appleIdProvider } from './providers'

export const appleIdSignIn = (): Promise<any> => {
  return isDesktopApp
    ? FirebaseAuth.signInWithRedirect(appleIdProvider)
    : FirebaseAuth.signInWithPopup(appleIdProvider)
}
